import React from "react";
import styled from "styled-components";
import { Button, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Skeleton } from "@mui/lab";
import handleCopy from "src/scenes/developer-portal/handle-copy";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";

const CardContainer = styled(Paper)`
    border-radius: 14px;
    padding: 32px;
    border: 2px solid transparent;
`;

const OrgTokenCard = ({
    organizationToken,
    loading,
    setLoading,
    setOrganizationToken,
    isDemo,
    setIsModalOpen,
}) => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);

    const getOrganizationToken = async () => {
        let response;
        if (isDemo) {
            response = null;
        } else {
            response = await request(`api/users/token`, { method: "GET" });
        }
        setOrganizationToken(response);
        setLoading(false);
    };

    const createOrganizationToken = async () => {
        try {
            await request(`/api/users/token`, { method: "POST" });
            setMessage(`You were successfully generated organization token`);
            setSeverity("success");
            setIsToastTriggered(true);
            setLoading(true);
            getOrganizationToken();
        } catch (e) {
            setMessage(`There was an error generating organization token`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    return (
        <CardContainer>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Stack direction="column" spacing={2}>
                        <Typography>Organization API Token</Typography>
                        {loading ? (
                            <Skeleton variant="rounded" width={210} height={30} />
                        ) : (
                            <Stack
                                direction="row"
                                alignItems="center"
                                style={{ width: "100%" }}
                                spacing={1}
                            >
                                <Typography style={{ fontSize: "12px", opacity: "0.7" }}>
                                    {organizationToken && organizationToken.token === null
                                        ? "No organisation token generated"
                                        : organizationToken.token}
                                </Typography>
                                {organizationToken.token && (
                                    <IconButton
                                        size="small"
                                        aria-label="copy token"
                                        onClick={() =>
                                            handleCopy({
                                                value: organizationToken.token,
                                                setMessage,
                                                setSeverity,
                                                setIsToastTriggered,
                                            })
                                        }
                                    >
                                        <ContentCopyIcon size="small" />
                                    </IconButton>
                                )}
                            </Stack>
                        )}
                    </Stack>
                </Grid>
                {!loading && (
                    <Grid item>
                        {organizationToken && organizationToken.token === null ? (
                            <Button variant="contained" onClick={createOrganizationToken}>
                                Generate
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={() => setIsModalOpen(true)}
                            >
                                Revoke
                            </Button>
                        )}
                    </Grid>
                )}
            </Grid>
        </CardContainer>
    );
};

export default OrgTokenCard;
